module.exports = __webpack_public_path__ + "static/media/bannerMobile.82801bde.png";